class BusinessTabs extends HTMLElement {
    constructor() {
        super();
        this.buttons = this.querySelectorAll('.tab-button');
        this.panels = this.querySelectorAll('.tab-panel');
        this.activeTabId = null;
        this.isTransitioning = false;
    }

    connectedCallback() {
        this.init();
    }

    init() {
        const activeButton = this.querySelector('.tab-button.active');
        if (activeButton) {
            this.activeTabId = activeButton.dataset.tab;
        }

        this.buttons.forEach(button => {
            button.addEventListener('click', (e) => this.handleTabClick(e));
        });

        this.updatePanelHeight();

        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                this.updatePanelHeight();
            }, 250);
        });
    }

    handleTabClick(e) {
        if (this.isTransitioning) return;

        const button = e.currentTarget;
        const tabId = button.dataset.tab;

        if (tabId === this.activeTabId) return;

        this.switchTab(tabId, button);
    }

    switchTab(tabId, button) {
        this.isTransitioning = true;

        this.buttons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        const currentPanel = this.querySelector(`[data-panel="${this.activeTabId}"]`);
        const newPanel = this.querySelector(`[data-panel="${tabId}"]`);

        if (currentPanel) {
            currentPanel.classList.remove('active');
        }

        setTimeout(() => {
            if (newPanel) {
                newPanel.classList.add('active');
                this.updatePanelHeight();
            }

            this.activeTabId = tabId;

            setTimeout(() => {
                this.isTransitioning = false;
            }, 400);
        }, 100);

        if (window.innerWidth < 768) {
            button.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
            });
        }
    }

    updatePanelHeight() {
        const activePanel = this.querySelector('.tab-panel.active');
        const contentContainer = this.querySelector('.tabs-content');

        if (activePanel && contentContainer) {
            const height = activePanel.offsetHeight;
            contentContainer.style.minHeight = `${height}px`;
        }
    }
}

if (!customElements.get('business-tabs')) {
    customElements.define('business-tabs', BusinessTabs);
}